/**
 *  Arquivo responsável por guardar o estado do componente
 *          orientação
 */
export default {
    mastersStudents: 0,
    doctoratesStudents: 0
}